import { EventContextMenu } from '../../event-context-menu/event-context-menu';
import { HeldUnitContextMenu } from '../../unit-context-menu/held-unit-context-menu/held-unit-context-menu';
import { MultiUnitContextMenu } from '../../unit-context-menu/multi-unit-context-menu';
import { ScheduledEventContextMenu } from '../../scheduled-event-context-menu/scheduled-event-context-menu';
import { UnitContextMenu } from '../../unit-context-menu/unit-context-menu';
import { UnitTimersContextMenu } from '../../unit-context-menu/unit-timers-context-menu';
import { useContextMenuStateRead } from '../context/use-context-menu-state';
import { HospitalContextMenu } from '../../hospital-context-menu/hospital-context-menu';
import { BoloContextMenu } from '../../bolos/bolo-queues/components/context-menu/bolo-context-menu';

export function ContextMenuQueueContent(): JSX.Element | null {
    const content = useContextMenuStateRead();

    if (!content) {
        return null;
    }
    const { kind } = content;

    switch (kind) {
        case 'EVENT':
            return <EventContextMenu eventId={content.entityId} />;
        case 'UNIT':
            return <UnitContextMenu unitId={content.entityId} />;
        case 'HELD_UNIT':
            return <HeldUnitContextMenu data={content.data} />;
        case 'MULTI_UNIT':
            return <MultiUnitContextMenu data={content.data} />;
        case 'SCHEDULED_EVENT':
            return <ScheduledEventContextMenu data={content.data} />;
        case 'UNIT_TIMER':
            return <UnitTimersContextMenu data={content.data} />;
        case 'HOSPITAL':
            return <HospitalContextMenu data={content.data} />;
        case 'BOLO':
            return <BoloContextMenu data={content.data} />;
        default:
            return null;
    }
}
